import React from "react";
import DictionaryButton from "./DictionaryButton";
import ProfileButton from "./ProfileButton";
import { NavigateFunction } from "react-router-dom";
import { getPlatform } from "@/lib/iap";
import GrowButton from "./GrowButton";
import CoursesButton from "./CoursesButton";
import HomeButton from "./HomeButton";
export type ActivePage =
  | "learn"
  | "dictionary"
  | "profile"
  | "grow"
  | "courses";

interface NavBarProps {
  activePage: ActivePage;
  navigate: NavigateFunction;
}

const NavBar: React.FC<NavBarProps> = ({ activePage, navigate }) => {
  const platform = getPlatform();

  return (
    <div
      className={`flex justify-evenly items-center align-middle fixed bottom-0 left-0 right-0 w-full border-t border-gray-300 bg-white ${
        platform === "web" ? "bottom-padding-web" : "pb-5"
      }`}
    >
      <HomeButton
        isActive={activePage === "learn"}
        onClick={() => {
          navigate("/home/learn");
        }}
      />
      <CoursesButton
        isActive={activePage === "courses"}
        onClick={() => {
          navigate("/home/courses");
        }}
      />
      <DictionaryButton
        isActive={activePage === "dictionary"}
        onClick={() => {
          navigate("/home/dictionary");
        }}
      />
      <GrowButton
        isActive={activePage === "grow"}
        onClick={() => {
          navigate("/home/grow");
        }}
      />
      <ProfileButton
        isActive={activePage === "profile"}
        onClick={() => {
          navigate("/home/profile");
        }}
      />
    </div>
  );
};

export default NavBar;
